import React from 'react';

export default class ErrorComponent extends React.Component {
  render () {
    return (
      <div className="c-error-component">
        <div className="c-error-component__container">
          <h1>500, Ooops something went wrong</h1>
          <h4>{this.props.error || 'We are not sure what, but we are trying to fix it.'}</h4>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorComponent.js